var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('panel-frame',{staticClass:"title-panel"},[_c('title-page',{staticClass:"title-panel__title"},[_vm._t("title")],2),_c('div',{staticClass:"title-panel__text text-size-medium"},[_vm._t("description")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }